import { notification } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Spinner } from 'components/ui/Spinner/Spinner'
import { Flex, Text } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { colors } from 'shared/constants/values'

type PropsType<T> = {
  id: number
  children: React.ReactNode
  label?: string
  showErrorMessage?: boolean
  data?: T | null
  setPersonalData: React.Dispatch<React.SetStateAction<T | null>>
  getPersonalData: (id: number, secondId?: string) => Promise<T>
}

export const PersonalData = <T,>({
  id,
  label = 'showData',
  children,
  showErrorMessage = true,
  data,
  setPersonalData,
  getPersonalData,
}: PropsType<T>) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const personalDataButtonHandler = async () => {
    try {
      setLoading(true)

      const personalData = await getPersonalData(id)

      if (personalData) {
        setPersonalData(personalData)
      }

      return personalData
    } catch (error) {
      if (showErrorMessage) {
        notification.error({
          message: t(getSharedKey('getDataError')),
          description: (error as Error).message,
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Flex>
      {!data && (
        <Flex onClick={personalDataButtonHandler} style={{ cursor: 'pointer' }}>
          {loading ? (
            <Spinner size={26} />
          ) : (
            <Text style={{ color: colors.green, fontSize: 16 }}>{t(getSharedKey(label))}</Text>
          )}
        </Flex>
      )}

      {data && children}
    </Flex>
  )
}
